Object.defineProperty(exports, "__esModule", {
  value: true
});

var {
  createRpcProxy
} = require("/app/node_modules/koa-rpc-call/browser");

var o = exports['default'] = {};
o["list"] = createRpcProxy("BoardContentNewsApi", "list", {
  "urlPrefix": "/rpc",
  httpMethod: 'GET'
});
o["get"] = createRpcProxy("BoardContentNewsApi", "get", {
  "urlPrefix": "/rpc",
  httpMethod: 'GET'
});
o["editPublishedNews"] = createRpcProxy("BoardContentNewsApi", "editPublishedNews", {
  "urlPrefix": "/rpc"
});
o["publishNews"] = createRpcProxy("BoardContentNewsApi", "publishNews", {
  "urlPrefix": "/rpc"
});
o["setNewsAsDraft"] = createRpcProxy("BoardContentNewsApi", "setNewsAsDraft", {
  "urlPrefix": "/rpc"
});
o["listDocumentGroups"] = createRpcProxy("BoardContentNewsApi", "listDocumentGroups", {
  "urlPrefix": "/rpc"
});
o["saveDocuementGroup"] = createRpcProxy("BoardContentNewsApi", "saveDocuementGroup", {
  "urlPrefix": "/rpc"
});
o["listDocuments"] = createRpcProxy("BoardContentNewsApi", "listDocuments", {
  "urlPrefix": "/rpc"
});
o["updateDocumentName"] = createRpcProxy("BoardContentNewsApi", "updateDocumentName", {
  "urlPrefix": "/rpc"
});
o["saveDocument"] = createRpcProxy("BoardContentNewsApi", "saveDocument", {
  "urlPrefix": "/rpc"
});
o["deleteDocumentFromContentNews"] = createRpcProxy("BoardContentNewsApi", "deleteDocumentFromContentNews", {
  "urlPrefix": "/rpc"
});
o["resendNotifications"] = createRpcProxy("BoardContentNewsApi", "resendNotifications", {
  "urlPrefix": "/rpc"
});
o["remove"] = createRpcProxy("BoardContentNewsApi", "remove", {
  "urlPrefix": "/rpc"
});
o["createDraft"] = createRpcProxy("BoardContentNewsApi", "createDraft", {
  "urlPrefix": "/rpc"
});
o["saveDraft"] = createRpcProxy("BoardContentNewsApi", "saveDraft", {
  "urlPrefix": "/rpc"
});
o["createNewsAndPublish"] = createRpcProxy("BoardContentNewsApi", "createNewsAndPublish", {
  "urlPrefix": "/rpc"
});
o["saveAndPublish"] = createRpcProxy("BoardContentNewsApi", "saveAndPublish", {
  "urlPrefix": "/rpc"
});
o["removeCoverImage"] = createRpcProxy("BoardContentNewsApi", "removeCoverImage", {
  "urlPrefix": "/rpc"
});